module.exports = __webpack_public_path__ + "static/media/rings.335b9d8f.svg";